import { Button, Grid } from "@mui/material";
import { useCallback } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { AncillarySubtype } from "../../../../api/services";
import DraftTimer from "../../_components/DraftTimer";
import { AdditionalDriversDetails, BasicDetails, BookingOwnerDetails, ExtraServices, FirstDriverDetails, InvoiceDetails, TotalToBePaid } from "../../sections";
import { IFormValues } from "../../types";
import ButtonBook from "./buttons/ButtonBook";
import CustomLoader from "../../../../../../util/component/CustomLoader";
import { useIsFetching } from "@tanstack/react-query";
import { ReactQueryKey, RentalType } from "../../../../types";

const CustomerDetails = () => {

    const navigate = useNavigate();

    const { t } = useTranslation('booking');

    const additionalDriversAncillary = useWatch<IFormValues>({
        name: `extraServices.ancillary.${AncillarySubtype.AdditionalDrivers}`
    });

    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });

    const handleReset = useCallback(() => {
        window.history.replaceState({}, document.title);
        navigate(0);
    }, []);

    const isFetchingMobilePrefixes = useIsFetching({
        queryKey: [ReactQueryKey.MobilePrefixes]
    });
    const isFetchingCountries = useIsFetching({
        queryKey: [ReactQueryKey.Countries]
    });

    return (
        <Grid container spacing={2} alignItems="start">
            <Grid container item xs={12} sm={12} md={6} spacing={2}>
                <Grid item xs={12}>
                    <BasicDetails />
                </Grid>
                <Grid item xs={12}>
                    <ExtraServices />
                </Grid>
                <Grid item xs={12}>
                    <TotalToBePaid />
                </Grid>
            </Grid>
            <Grid container item xs={12} sm={12} md={6} spacing={2}>
                <Grid item xs={12}>
                    <FirstDriverDetails />
                </Grid>
                {rentalType === RentalType.CORPORATE &&
                    <Grid item xs={12}>
                        <InvoiceDetails/>
                    </Grid>
                }
                <Grid item xs={12}>
                    <BookingOwnerDetails />
                </Grid>
                {additionalDriversAncillary ?
                    <Grid item xs={12}>
                        <AdditionalDriversDetails />
                    </Grid>
                    : undefined
                }
                <Grid container item mt={1} justifyContent="end" columnGap={2}>
                    <Button
                        variant="outlined"
                        onClick={handleReset}
                    >
                        {t('label.reset')}
                    </Button>
                   {/* <ButtonOffer />*/}
                    <ButtonBook />
                </Grid>
            </Grid>
            <DraftTimer />
            <CustomLoader
                loading={
                    !!isFetchingMobilePrefixes ||
                    !!isFetchingCountries
                }
            />
        </Grid>
    );
};

export default CustomerDetails;
